import styled, { css } from 'styled-components';
import { FontSize, FontWeight, spacing } from 'commons';

export const Main = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  min-width: 144px;
  max-width: 144px;
  white-space: nowrap;
  height: ${spacing.input.height};
  border-radius: ${spacing.input.borderRadius} 0px 0px
    ${spacing.input.borderRadius};
  border: 1px solid ${({ theme }) => theme.neutral_300};
  border-right: none;
  font-weight: ${FontWeight.regular};
  font-size: ${FontSize.font12};
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.neutral_100};
  color: ${({ theme }) => theme.neutral_500};
  border-radius: inherit;
  padding: 8px;
  padding-right: 4px;
  font-size: inherit;
  font-weight: inherit;
  cursor: pointer;
`;

export const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  min-width: 24px;

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const Content = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  gap: 12px;
  top: 0;
  left: 0;
  width: 100%;
  max-height: 32vh;
  padding: 8px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.neutral_100};
  box-shadow: 1px 3px 12px -4px ${({ theme }) => theme.neutral_300};
  z-index: 1;
`;

const Option_selected = css`
  background-color: ${({ theme }) => theme.neutral_200};
`;
const Option_available = css`
  cursor: pointer;

  &:hover {
    outline: 1px solid ${({ theme }) => theme.neutral_500};
  }
`;

export const Option = styled.button<{ $isSelected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-color: transparent;
  gap: 12px;
  font-size: inherit;
  font-weight: inherit;
  padding: 8px;
  border-radius: 4px;

  ${({ $isSelected }) => ($isSelected ? Option_selected : Option_available)}
`;
